import { ChangeDetectionStrategy, Component, input, InputSignal, OnInit, signal, WritableSignal, ViewEncapsulation, ContentChild, TemplateRef, effect, OutputEmitterRef, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TreeTableModule } from 'primeng/treetable';
import { TreeNode } from 'primeng/api';
import { getLevelsState, updateNodeLoading } from './_config/tree.functions';
import { TreeConfig } from './_config/tree.model';

@Component({
  selector: 'plyca-ui-tree',
  templateUrl: './tree.component.html',
  styleUrl: './tree.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TreeTableModule, TranslateModule, NgTemplateOutlet, ProgressSpinnerModule]
})
export class PlycaUiTreeComponent implements OnInit {
  @ContentChild('tableTemplateBody') tableTemplateBody!: TemplateRef<any>;

  public config: InputSignal<TreeConfig> = input.required<TreeConfig>();
  public treeDataSig: WritableSignal<TreeNode[]> = signal<TreeNode[]>([]);
  public nodeExpandedChange: OutputEmitterRef<TreeNode> = output<TreeNode>();

  public hasPaginator = signal(false);

  ngOnInit(): void {
    this.treeDataSig.set(this.config().node);
  }

  constructor() {
    effect(
      () => {
        if (this.config().node) {
          this.treeDataSig.set(this.config().node);
        }
      },
      { allowSignalWrites: true }
    );
  }

  public onNodeExpand(event: { node: TreeNode }): void {
    if (!event.node.children || event.node.children.length === 0) {
      this._setNodeLoading(event.node.key, true);
      this.nodeExpandedChange.emit(event.node);
    }
  }

  public getLevels(node): { level: number; continue: boolean }[] {
    return getLevelsState(node, this.treeDataSig());
  }

  private _setNodeLoading(nodeKey: string, loading: boolean): void {
    const updatedTree = updateNodeLoading(this.treeDataSig(), nodeKey, loading);
    this.treeDataSig.set(updatedTree);
  }
}
